import React from 'react'
import {useLocation} from 'react-router-dom'
import {Box, VisuallyHidden} from '@chakra-ui/react'
// import {useLivePreviewCtx} from '../context/live-preview-context-provider'
// import {EntryProps} from '../typescript/components'
// import {Page} from '../typescript/pages'
import RenderComponents from '../../components/editorial-components/render-components'
import Skeleton from './skeleton'
import {useGetEditorialPage} from '../../custom-api/hooks/use-get-editorial-page'
import PlpStickyBar from '../../components/editorial-components/plp-sticky-bar'
import {useServerContext} from '@salesforce/pwa-kit-react-sdk/ssr/universal/hooks'
import {Helmet} from 'react-helmet'
import loadable from '@loadable/component'
import {MAX_CACHE_AGE_HP, STALE_WHILE_REVALIDATE_HP} from '../../constants'
import {getConfig} from '@salesforce/pwa-kit-runtime/utils/ssr-config'
const PageNotFound = loadable(() => import('./../page-not-found'))

const EditorialPage = () => {
    const {res} = useServerContext()
    const {data, error, isFetching, isFetched, isLoading, isSuccess, isError} =
        useGetEditorialPage()
    const entries = {...data}
    const location = useLocation()
    const {customParams} = getConfig()
    const currentPath = 'https://' + customParams.currentHost + location.pathname

    if (res) {
        res.set(
            'Cache-Control',
            `s-maxage=${MAX_CACHE_AGE_HP}, stale-while-revalidate=${STALE_WHILE_REVALIDATE_HP}`,
        )
    }

    if (error || (data === null && !isLoading)) {
        if (res) res.status(404)
        return <PageNotFound />
    }

    const seo = entries?.seo_standard || {}
    const metaTitle = seo?.meta_title
    const metaDescription = seo?.meta_description

    const webPageSchemaMarkup = {
        '@context': 'https://schema.org/',
        '@type': 'WebPage',
        name: metaTitle,
        description: metaDescription,
        url: currentPath,
    }
    return (
        <Box data-gtm={location?.pathname === '/' ? 'homepage' : 'psp-page'}>
            <Helmet>
                {metaTitle && <title>{metaTitle}</title>}
                {metaDescription && <meta name="description" content={metaDescription} />}
                <script type="application/ld+json">
                    {JSON.stringify(webPageSchemaMarkup, null, 2)}
                </script>
            </Helmet>
            {seo?.h1_title && (
                <VisuallyHidden>
                    <h1>{seo.h1_title}</h1>
                </VisuallyHidden>
            )}
            {(isFetching || isLoading) &&
                !isFetched &&
                Array(entries?.page_components?.length || 4)
                    .fill()
                    .map((_, index) => <Skeleton key={index} />)}

            {data?.sticky_menu?.length > 0 && <PlpStickyBar data={data?.sticky_menu[0]} />}

            {isSuccess && !!Object.keys(entries).length && (
                <RenderComponents
                    pageComponents={entries?.page_components}
                    contentTypeUid="page"
                    entryUid={entries?.uid}
                    locale={entries?.locale}
                    isFetching={isFetching}
                />
            )}

            {isError && <>{/* handle error */}</>}
        </Box>
    )
}

export default EditorialPage
